var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"color":(_vm.value && `primary`) || `grey`},domProps:{"textContent":_vm._s(_vm.buttonText)}},'v-btn',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }